import styled from "styled-components";

export const StyledPaymentSection = styled.div`
    width: 100%;
    min-height: 100dvh;
    @media (min-width: 900px) {
        display: flex;
    }

    .StripeElement {
        margin-bottom: 20px;
    }

    .column {
        width: 100%;
        padding: 30px 20px;
        @media (min-width: 576px) {
            padding: 50px;
        }
        @media (min-width: 900px) {
            width: 50%;
        }
        .email-wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            background-color: rgba(236, 236, 236, 1);
            border-radius: 48px;
            padding: 15px 20px;
            margin-bottom: 35px;
            .title {
                color: rgba(119, 119, 119, 1);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
            .value {
                color: var(--text-color);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
        }
        .btn {
            margin: 0 auto 50px 0;
            min-width: 87px;
            padding: 9px 5px;
            @media (min-width: 576px) {
                margin: 0 auto 100px 0;
            }
            &:hover {
                background: ${({theme}) => theme?.light?.primary};
                color: var(--white);
            }
        }
        .pricing-holder {
            width: 100%;
            max-width: 402px;
            grid-template-columns: 1fr;
            .col {
                background: transparent;
                box-shadow: none;
                .btn {
                    margin-bottom: 30px;
                }
                .no-card {
                    .btn {
                        background: rgba(205, 205, 205, 1);
                    }
                }
            }
        }

        .col-title {
            font-size: 20px;
            line-height: 24px;
            font-weight: 400;
            margin-bottom: 25px;
            @media (min-width: 576px) {
                font-size: 22px;
                line-height: 26px;
            }
        }
        .label {
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
        }
        .minMargin {
            margin-bottom: 10px;
        }
        .submit-btn {
            margin-bottom: 22px;
        }
        .input-wrap {
            display: flex;
            .yearInput {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
            .cvcInput {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }
        .footer-wrap {
            list-style: none;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 20px;
            li {
                font-size: 14px;
                line-height: 18px;
                font-weight: 300;
                cursor: pointer;

                &.separator {
                    height: 24px;
                    border-left: 1px solid rgba(205, 205, 205, 1);
                }
                &.img-li {
                    display: flex;
                }
                &.stripe {
                    font-weight: 400;
                }
            }
        }
    }
    .col-2 {
        margin: 0 auto;
        max-width: 750px;
        input::placeholder {
            color: rgba(205, 205, 205, 1);
        }
        .react-select__placeholder {
            color: rgba(205, 205, 205, 1);
        }
    }
`;
